import { RootState } from 'store';

export const companyAvailabilityFiltersSelector = (state: RootState) => state.companyAvailabilityFilters.filters;
